<template>
  <div class="wrap">
    <div class="wrap-title">
      <TitleControl title="发票抬头" :showSearch="false">
        <div slot="control" class="control-btn">
          <div
            class="add"
            @click="
              handleEdit({
                header: '',
                identify_number: '',
              })
            "
          >
            新增
          </div>
        </div>
      </TitleControl>
    </div>
    <div class="wrap-list">
      <div class="list-item" v-for="item in list">
        <div class="header">
          <div class="name">普通发票抬头-企业</div>
          <div class="control">
            <span @click="handleEdit(item)">编辑</span> |
            <span @click="handleDelect(item)">删除</span>
          </div>
        </div>
        <div class="content">
          <div class="header-value">{{ item.header }}</div>
          <div class="identify-number">{{ item.identify_number }}</div>
          <div class="email">{{ item.email || "-" }}</div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="edit_visible"
      center
      append-body
      width="800px"
      :visible.sync="edit_visible"
    >
      <div class="content">
        <div class="content-header">{{ edit_type }}抬头</div>
        <div class="content-center">
          <div class="form">
            <div class="form-label">发票抬头</div>
            <input
              class="form-input"
              type="text"
              placeholder="请填写发票抬头"
              v-model="header_params.header"
            />
            <div class="form-label">单位税号</div>
            <input
              class="form-input"
              type="text"
              placeholder="请填写单位税号"
              v-model="header_params.identify_number"
            />
            <div class="form-label">邮箱</div>
            <input
              class="form-input"
              type="text"
              placeholder="请填写邮箱"
              v-model="header_params.email"
            />
          </div>
        </div>
        <div class="content-footer">
          <div class="btn cancel" @click="edit_visible = false">取消</div>
          <div class="btn confirm" @click="handleConfirm">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { BillService } from "@/common/service";
import TitleControl from "@/components/module/title-control.vue";
export default {
  components: { TitleControl },
  data() {
    return {
      list: [],
      params: { page: 1, page_num: 20 },
      edit_visible: false,
      edit_type: "新增",
      header_params: {
        header: "",
        identify_number: "",
        email: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      BillService.getHeaderList(this.params).then(({ data }) => {
        this.list = data.list;
      });
    },
    handleEdit(item) {
      this.edit_type = item.id ? "编辑" : "新增";
      this.header_params = item;
      this.edit_visible = true;
    },
    handleConfirm() {
      if (!this.header_params.header)
        return this.$message.error("请填写发票抬头");
      if (!this.header_params.identify_number)
        return this.$message.error("请填写单位税号");
      if (!this.header_params.email) return this.$message.error("请填写邮箱");
      BillService.selBillHeader(this.header_params).then(() => {
        this.$message.success(this.edit_type + "成功");
        this.edit_visible = false;
        this.getList();
      });
    },
    handleDelect(item) {
      let that = this;
      this.showConfirmPopup("确定要删除该抬头？")
        .then(() => {
          BillService.delBillHeader({ id: item.id }).then(({ data }) => {
            that.$message.success("删除成功！");
            that.getList();
          });
        })
        .catch((_) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: calc(100% - 120px - 100px);
  display: flex;
  flex-direction: column;
  min-width: 900px;
  align-items: center;
  .wrap-title {
    width: 70%;
    .control-btn {
      display: flex;
      justify-content: flex-end;
    }
    .add {
      width: 84px;
      height: 38px;
      background: #2a63f3;
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
  }
  .wrap-list {
    width: 70%;
    margin-top: 20px;
    .list-item {
      height: 158px;
      background: #ffffff;
      border: 1px solid #cecece;

      margin-bottom: 20px;
      * {
        box-sizing: border-box;
      }
      .header {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background: #f7f7f7;
        .name {
          font-size: 16px;
          font-weight: 500;
          color: #141414;
        }
        .control {
          font-size: 16px;
          font-weight: 400;
          color: #141414;
          span {
            cursor: pointer;
          }
        }
      }
      .content {
        height: 110px;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .header-value {
          font-size: 18px;
          font-weight: 400;
          color: #141414;
        }
        .identify-number {
          font-size: 16px;
          font-weight: 400;
          color: #141414;
        }
        .email {
          font-size: 16px;
          font-weight: 400;
          color: #141414;
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 10px;
  }
  .content {
    width: 100%;
    .content-header {
      width: 100%;
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      color: #000000;
    }
    .content-center {
      width: 100%;
      height: 350px;
      margin: 20px 0;
      .form {
        width: 400px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .form-label {
          font-size: 16px;
          font-weight: 500;
          color: #141414;
          margin-bottom: 20px;
        }
        .form-input {
          width: 100%;
          height: 45px;
          border: 1px solid rgba(151, 151, 151, 0.5);
          box-sizing: border-box;
          outline: none;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 20px;
          padding: 15px;
          box-sizing: border-box;
        }
        .form-input::placeholder {
          color: rgba(151, 151, 151, 0.5);
        }
      }
    }
    .content-footer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        width: 200px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 22px;
        font-weight: 400;
        box-sizing: border-box;
        border-radius: 10px;
        cursor: pointer;
      }
      .cancel {
        border: 1px solid #0054f7;
        color: #0054f7;
      }
      .confirm {
        background: #0054f7;
        color: #ffffff;
        margin-left: 20px;
      }
    }
  }
}
</style>
